






import { Component, Vue } from 'vue-property-decorator';
import EmployeesTable from '@/modules/employees/components/EmployeesTable.vue';

@Component({
  components: {
    EmployeesTable,
  },
})
export default class EmployeesOverview extends Vue {

}
